import { Box, IconButton, TableCell } from '@mui/material'
import { TooltipCC } from 'components/common'
import TableComponent from 'components/Table/Table'
import { IconViewDetail } from 'pages/service-package-management/assets'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { TABLE_HEAD_MONITOR_ROOM } from '../monitor.constant'

const TableMonitorRoom = (props) => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const {
        page,
        size,
        handleChangePage,
        handleChangeLimit,
        tableData
    } = props

    const data = tableData?.data || []
    const total = tableData?.total || 0

    const actionsCell = (row) => {
        return (
            <TableCell align="center" sx={{ width: 120 }}>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        columnGap: 2
                    }}
                >
                    <TooltipCC
                        title={t('common:tooltip.view')}
                        placement="bottom-start"
                    >
                        <IconButton
                            onClick={() =>
                                navigate(`detail-monitor/${row?.roomId}`)
                            }
                        >
                            <IconViewDetail />
                        </IconButton>
                    </TooltipCC>
                </Box>
            </TableCell>
        )
    }

    return (
        <TableComponent
            headCells={TABLE_HEAD_MONITOR_ROOM}
            data={data}
            page={page}
            size={size}
            total={total}
            handleChangePage={(event, currentPage) => {
                handleChangePage(currentPage - 1)
            }}
            handleChangeLimit={handleChangeLimit}
            renderActionsCell={actionsCell}
            t={t}
        />
    )
}

export default TableMonitorRoom